export const isVendorRfqEnabled = (): boolean =>
  String(process.env.REACT_APP_ENABLE_VENDOR_RFQ || '').trim().toLowerCase() === 'true';
